import type { SessionUserDTO } from "@shared/contracts";
import type { SessionUserModel } from "./auth.model";

/**
 * The boundary. Everything above it speaks the domain; everything below it speaks the
 * service. Dates become Dates here and nowhere else, so no component ever has to know
 * whether it is holding a string.
 */
export function toSessionUser(dto: SessionUserDTO): SessionUserModel {
  return {
    id: dto.id,
    email: dto.email,
    name: dto.name,
    imageUrl: dto.imageUrl,
    emailVerified: dto.emailVerified,
    createdAt: new Date(dto.createdAt),
  };
}
